export default __webpack_public_path__ + "assets/images/429743554800729cdf56465d5b0f8e41.svg";